import { useFeatureFlagVariant } from "@/utils/kameleoon/useFeatureFlagVariant";
export function useIsConfirmationPageDisabled() {
    const confirmationDisabledVariant = "b";
    const isConfirmationPageDisabled = useFeatureFlagVariant("cdp_confirmation_page_removal", confirmationDisabledVariant);
    return isConfirmationPageDisabled;
}
